<div class="user-selector-container">
    <ion-label position="stacked" *ngIf="label">{{ label }}<app-required-asterisk [show]="!isPredefined" /></ion-label>
    <ion-searchbar 
        *ngIf="!isPredefined"
        [placeholder]="placeholder"
        [(ngModel)]="searchText"
        (ionInput)="onSearchInput($event)"
        (click)="onSearchbarClick()"
        (ionBlur)="onSearchbarBlur()"
        (ionClear)="onSearchInput()"
        debounce="300">
    </ion-searchbar>

    <div class="search-results-popover" *ngIf="isPopoverOpen && filteredUsers.length > 0">
        <div class="popover-item" 
            *ngFor="let user of filteredUsers"
            (mousedown)="selectUser(user, $event)"
            (click)="selectUser(user, $event)"
            [class.selected]="isSelected(user)">
        {{ user.userName }}
        </div>
    </div>

    <div class="selected-users-container" *ngIf="selectedUsers.length > 0">
        <div class="user-chip" [class.predefined]="isPredefined" *ngFor="let user of selectedUsers">
        {{ user.userName }}
        <ion-icon *ngIf="!isPredefined" name="close" (click)="removeUser(user)"></ion-icon>
        </div>
    </div>
</div>